/**
 * Collects client-side marketing attribution fields for Marketo form 2657.
 * Must be called in a browser context (client component).
 */

export interface MarketoTrackingFields {
    /** Full page URL including search. Used for visitorData.pageURL. */
    pageUrlFull: string;
    /** location.search (e.g. ?utm_source=email). Used for visitorData.queryString. */
    pageSearch: string;
    /** _mkto_trk cookie for Munchkin association. */
    mktoTrkCookie: string;
    // Standard UTM URL params
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;
    utmContent: string;
    utmTerm: string;
    utmMethod: string;
    utmRegion: string;
    utmSegment: string;
    // Other URL params
    ref: string;
    userType: string;
    utmType: string;
    buyNow: string;
    // Cookie-based
    utmLanguage: string;
    utmCountry: string;
}

export function getCookie(name: string): string {
    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
}

export function collectMarketoTrackingFields(buyNow: boolean): MarketoTrackingFields {
    const searchParams = new URLSearchParams(window.location.search);
    const getParam = (key: string) => searchParams.get(key) ?? '';
    return {
        pageUrlFull: window.location.href,
        pageSearch: window.location.search,
        mktoTrkCookie: getCookie('_mkto_trk'),
        utmSource: getParam('utm_source'),
        utmMedium: getParam('utm_medium'),
        utmCampaign: getParam('utm_campaign'),
        utmContent: getParam('utm_content'),
        utmTerm: getParam('utm_term'),
        utmMethod: getParam('utm_method'),
        utmRegion: getParam('utm_region'),
        utmSegment: getParam('utm_segment'),
        ref: getParam('ref'),
        userType: getParam('user_type'),
        utmType: getParam('utm_type'),
        buyNow: buyNow.toString(),
        utmLanguage: getCookie('utm_language'),
        utmCountry: getCookie('utm_country'),
    };
}
